import axios from 'axios'
import * as types from "../mutation-types";

// state
export const state = {
    data: null,
    data_loaded: false,
    ticket: null,
    ticket_loaded: null,
    ticket_error:null
}

// getters
export const getters = {
    data: state => state.data,
    data_loaded: state => state.data_loaded,
    site_error: state => state.site_error,

    ticket: state => state.ticket,
    ticket_loaded: state => state.ticket_loaded,
    ticket_error: state => state.ticket_error,
}

// mutations
export const mutations = {
    [types.START_FETCH_TICKETS](state)
    {
        state.data_loaded = false;
    },
    [types.FETCH_TICKETS_SUCCESS](state, {tickets})
    {
        state.data = tickets;
        state.data_loaded = true;
    },
    [types.FETCH_TICKETS_FAILURE](state, {tickets})
    {
        state.data = null;
        state.data_loaded = true;
        state.site_error = true;
    },
    [types.CLEAR_TICKET](state)
    {
        state.ticket_loaded = false;
        state.ticket = null;
        state.ticket_error = false;
    },
    [types.START_FETCH_TICKET](state)
    {
        state.ticket_loaded = false;
    },
    [types.FETCH_TICKET_SUCCESS](state, {ticket})
    {
        state.ticket = ticket;
        state.ticket_loaded = true;
    },
    [types.FETCH_TICKET_FAILURE](state, {ticket})
    {
        state.ticket = null;
        state.ticket_loaded = true;
        state.ticket_error = true;
    },
}

// actions
export const actions = {
    async getTickets({ commit }, payload)
    {
        if (Object.keys(payload).length === 0)
        {
            commit(types.START_FETCH_TICKETS);
        }
        try
        {
            let {data} = await axios.post('/api/tickets/show', payload);
            commit(types.FETCH_TICKETS_SUCCESS, {tickets: data})
        } catch (e)
        {
            commit(types.FETCH_TICKETS_FAILURE)
        }
    },

    async getTicket({commit}, id)
    {
        commit(types.START_FETCH_TICKET);
        try
        {
            let {data} = await axios.post('/api/tickets/get', { id : id});
            commit(types.FETCH_TICKET_SUCCESS, {ticket: data})
        } catch (e)
        {
            commit(types.FETCH_TICKET_FAILURE)
        }
    },

    async clearTicket({commit}, id)
    {
        commit(types.CLEAR_TICKET);
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/tickets.js